module.exports = __webpack_public_path__ + "static/media/assessmentx.b8a8b972.svg";